import React, { FC } from 'react';
import { SearchAutoCorrect } from './SearchAutoCorrect';
import { Connect, PropsFromRedux } from './SearchAutoCorrectWizardContainer';

type Props = PropsFromRedux;

export const RawSearchAutoCorrectWizard: FC<Props> = ({
  displayAutoCorrect,
}) => {
  if (!displayAutoCorrect) return null;

  return <SearchAutoCorrect />;
};

export const SearchAutoCorrectWizard = Connect(RawSearchAutoCorrectWizard);
